import type { PropsWithChildren } from 'react';
import type React from 'react';

import { PageScrollPositionContext } from './context';
import { usePageScrollPositionState } from './pageScrollPositionState';

export const PageScrollPositionProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const info = usePageScrollPositionState();

	return <PageScrollPositionContext.Provider value={info}>{children}</PageScrollPositionContext.Provider>;
};
